import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './banner.css';
import productImag from '../../../assets/banner_imgaes/product_image.png';
import newsImag from '../../../assets/banner_imgaes/news_image.png';
import partners_images from '../../../assets/banner_imgaes/partners_images.png';
import contact from '../../../assets/banner_imgaes/contact.png';

import factoringTop from '../../../assets/banner_imgaes/factoringTop.png';
import factoringBottom from '../../../assets/banner_imgaes/factoringBottom.png';
import tradeTop from '../../../assets/banner_imgaes/tradeTop.png';
import tradeBottom from '../../../assets/banner_imgaes/tradeBottom.png';
import supplyTop from '../../../assets/banner_imgaes/supplyTop.png';
import supplyBottom from '../../../assets/banner_imgaes/supplyBottom.png';
import leasingTop from '../../../assets/banner_imgaes/leasingTop.png';
import leasingBottom from '../../../assets/banner_imgaes/leasingBottom.png';
import newsTextImg from '../../../assets/banner_imgaes/newsTextImg.svg';
import partnerTextImg from '../../../assets/banner_imgaes/parterTextImg.svg';
import serviceTextImg from '../../../assets/banner_imgaes/serviceTextImg.svg';
import contactTextImg from '../../../assets/banner_imgaes/contactTextImg.svg';
import aboutBottom from '../../../assets/banner_imgaes/aboutBottom.jpg';
import aboutTop from '../../../assets/banner_imgaes/aboutTop.png';
import aboutDefault from '../../../assets/banner_imgaes/aboutDefault.png';
import aboutDefaultText from '../../../assets/banner_imgaes/aboutDefaultText.svg';

import statement_bg from '../../../assets/banner_imgaes/statement_bg.jpg';
import statement_text from '../../../assets/banner_imgaes/statement_text.svg';
import { BreathingImage } from '../BreathingImage';
import { AboutUs } from './AboutUs';
import { preloadImages } from '../../../utils';

const bannerList = [
  { src: '/about1', alt: '关于我们', image: aboutBottom },
  { src: '/about2', alt: '关于我们', image: aboutTop },
  { src: '/about3', alt: '关于我们', image: aboutDefault },
  { src: '/about4', alt: '关于我们', image: aboutDefaultText },
  // 以上三个是故意写错src的，目的是将图片加入缓存中，因为关于我们这个页面组件是单独写的没在这
  {
    src: '/solution/factoring',
    alt: '保理业务管理系统',
    image: factoringTop,
    image2: factoringBottom,
    desc: '挚云保理业务管理系统，内置风控模型，多渠道接入，全场景支持，实现保前、保中、保后全链路管理，助力保理业务有序开展新消息。',
  },
  {
    src: '/solution/trade',
    alt: '贸易系统',
    image: tradeTop,
    image2: tradeBottom,
    desc: '通过贸易系统实现订单、库存、财务等信息的集中管理，提高整体运营效率和管理水平。',
  },
  {
    src: '/solution/supply',
    alt: '供应链金融系统',
    image: supplyTop,
    image2: supplyBottom,
    desc: '优化供应链流程，实现供应商协作、库存控制、订单管理的一体化管理，帮助企业构建线上供应链金融生态体系。',
  },
  {
    src: '/solution/financial/leasing',
    alt: '融资租赁系统',
    image: leasingTop,
    image2: leasingBottom,
    desc: '租赁业务模式全流程数字化，直租、回租、转租等，对租赁物进行全生命周期数字化管理，助力融资租赁公司持续发展。',
  },

  {
    src: '/product/services',
    alt: '产品服务',
    image: productImag,
    textImg: serviceTextImg,
  },
  {
    src: '/qualification/certificate',
    alt: '新闻资讯',
    image: newsImag,
    textImg: newsTextImg,
  },
  { src: '/details', alt: '新闻资讯', image: newsImag, textImg: '' },
  {
    src: '/partners',
    alt: '合作伙伴',
    image: partners_images,
    textImg: partnerTextImg,
  },
  {
    src: '/contact',
    alt: '联系我们',
    image: contact,
    textImg: contactTextImg,
  },
  {
    src: '/disclaimers',
    alt: '免责声明',
    image: statement_bg,
    textImg: statement_text,
  },
];

const imageList = bannerList.reduce((acc, curr) => {
  acc.push(curr.image);
  if (curr.image2) acc.push(curr.image2);
  if (curr.textImg) acc.push(curr.textImg);
  return acc;
}, []);

const Banner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    preloadImages(imageList);
  }, []);

  const scrollToAbout = () => {
    if (
      location.pathname !== '/about' &&
      location.pathname !== '/qualification/certificate' &&
      location.pathname !== '/details' &&
      location.pathname !== '/disclaimers'
    ) {
      navigate('/contact');
    }
  };

  const needBreathing = [
    '/solution/factoring',
    '/solution/trade',
    '/solution/supply',
    '/solution/financial/leasing',
  ].includes(location.pathname);

  const currentBanner = bannerList.find(
    (item) => item.src === location.pathname,
  );

  const clickHandler = () => {
    navigate('/contact');
  };

  if (location.pathname.includes('about')) {
    return <AboutUs />;
  }

  return (
    <div>
      {needBreathing ? (
        <BreathingImage
          src1={currentBanner.image}
          src2={currentBanner.image2}
          alt={currentBanner.alt}
          desc={currentBanner.desc}
          clickHandler={clickHandler}
        />
      ) : currentBanner?.image ? (
        <div style={{ height: 500 }} className={'header_banner_img_wrapper'}>
          {currentBanner.textImg && (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img style={{ zIndex: 1 }} src={currentBanner.textImg} alt="" />
            </div>
          )}
          <img
            className={'header_banner_img2'}
            src={currentBanner?.image}
            key={currentBanner?.src}
            alt={currentBanner?.alt}
            onClick={scrollToAbout}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
